import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MainNavItemsService } from '../../services/main-nav-items.service';

@Component({
  selector: 'sh-main-nav-business-desktop',
  templateUrl: './main-nav-business-desktop.component.html',
  styleUrl: './main-nav-business-desktop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavBusinessDesktopComponent {
  @Input()
  bigger = false;

  constructor(public items: MainNavItemsService) {}
}
